




import { pageFactory } from '@/main/pages/pageFactory';

import { CorporateAccountRequestStatusPage } from '../store/CorporateAccountRequestStatusPage';


export default pageFactory('CorporateAccountRequestStatusFormListIframe', CorporateAccountRequestStatusPage).extend({
	computed: {
		src() {
			return '/DMS3/CPF/CorporateAccountRequestStatus/List';
		},
	},
	data() {
		return {
			DealerId: this.$route.query.dealerTenantCode,
			isOEM: true as boolean,
		};
	},
});
